import React, { useEffect, useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiPhoneCall, FiArrowUpRight } from 'react-icons/fi';
import './Navbar.css';
import useSiteSettings from '../../hooks/useSiteSettings';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { settings } = useSiteSettings();

  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const nav = useMemo(() => [
    { to: '/', label: 'Home' },
    { to: '/listing', label: 'Properties' },
    { to: '/projects', label: 'Projects' },
    { to: '/blog', label: 'Blog' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ], []);

  return (
    <>
      <header className={`nb ${scrolled ? 'is-scrolled' : ''}`}>
        <div className="container nb__container">
          <NavLink to="/" className="nb__brand" aria-label="Go to home">
            <span className="nb__logo">{settings.logoText || 'RC'}</span>
            <span className="nb__brandText"><span className="nb__brandTop">{settings.siteName || 'RealCity'}</span><span className="nb__brandSub">{settings.siteTagline || 'High-Rise & Investment'}</span></span>
          </NavLink>
          <nav className="nb__nav" aria-label="Primary navigation">
            {nav.map((n) => <NavLink key={n.to} to={n.to} end={n.to === '/'} className={({ isActive }) => `nb__link ${isActive ? 'is-active' : ''}`}>{n.label}</NavLink>)}
          </nav>
          <div className="nb__actions">
            <a className="nb__call" href={`tel:${settings.contactPhone || '+923001234567'}`} title="Call us"><FiPhoneCall /><span className="d-none d-lg-inline">{settings.contactPhone || '+92 300 1234567'}</span></a>
            <NavLink to="/projects" className="nb__cta">Explore Projects <FiArrowUpRight /></NavLink>
            <button className="nb__toggle" type="button" aria-label="Open menu" onClick={() => setOpen(true)}><FiMenu /></button>
          </div>
        </div>
      </header>
      <div className={`nbd ${open ? 'is-open' : ''}`} aria-hidden={!open}>
        <div className="nbd__backdrop" onClick={() => setOpen(false)} />
        <aside className="nbd__panel" role="dialog" aria-modal="true">
          <div className="nbd__top"><div className="nbd__brand"><span className="nb__logo">{settings.logoText || 'RC'}</span><div><div className="nbd__brandTop">{settings.siteName || 'RealCity'}</div><div className="nbd__brandSub">{settings.siteTagline || 'High-Rise & Investment'}</div></div></div><button className="nbd__close" type="button" aria-label="Close menu" onClick={() => setOpen(false)}><FiX /></button></div>
          <div className="nbd__links">{nav.map((n) => <NavLink key={n.to} to={n.to} end={n.to === '/'} className={({ isActive }) => `nbd__link ${isActive ? 'is-active' : ''}`}>{n.label}</NavLink>)}</div>
          <div className="nbd__bottom"><a className="nbd__btn nbd__btn--ghost" href={`tel:${settings.contactPhone || '+923001234567'}`}><FiPhoneCall /> Call Now</a><NavLink to="/contact" className="nbd__btn nbd__btn--primary">Contact Us <FiArrowUpRight /></NavLink></div>
        </aside>
      </div>
    </>
  );
}
